export default __webpack_public_path__ + "static/1.2_FR-e2e3cacad839daa20d133ec4c2536422.webp";